import React from "react";

/**
 * Renders the Azerbaijani Manat symbol (₼) as a styled text glyph.
 * Uses Inter font which supports U+20BC properly.
 */
export default function Manat({ size = 20, color = "currentColor", style = {}, strokeWidth, ...rest }) {
  return (
    <span
      className="manat-glyph"
      style={{
        fontSize: `${size}px`,
        color,
        fontWeight: 900,
        lineHeight: 1,
        display: "inline-block",
        fontFamily: "Inter, -apple-system, BlinkMacSystemFont, 'Segoe UI', Arial, sans-serif",
        ...style,
      }}
      {...rest}
    >
      ₼
    </span>
  );
}
